// extracted by mini-css-extract-plugin
export default {"label":"label---htTS8","isEmptyMessage":"isEmptyMessage---b0qYm"};